export const SampleTag = ({ children = "Illustrative example · sample data, not real vessel data", testId, light }) => (
  <p data-testid={testId} className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.15em] ${light ? "border-[#7a4524]/30 bg-[#7a4524]/5 text-[#7a4524]" : "border-[#D4A373]/40 bg-[#D4A373]/10 text-[#D4A373]"}`}>
    <span className={`h-1.5 w-1.5 rounded-full ${light ? "bg-[#7a4524]" : "bg-[#D4A373]"}`} />
    {children}
  </p>
);
